import classnames from "classnames";
import { useEffect, useState } from "react";

import arrow from "../assets/icons/arrow-right.svg";
import { usePagination } from "../hooks/usePagination";

const Pagination = ({ onPageChange, totalCount, siblingCount = 1, currentPage, pageSize, className }) => {
  const paginationRange = usePagination({
    currentPage,
    totalCount,
    siblingCount,
    pageSize,
  });

  const [pageInput, setPageInput] = useState(currentPage);

  useEffect(() => {
    setPageInput(currentPage);
  }, [currentPage]);

  // If there are less than 2 items in pagination range we shall not render the component
  if (currentPage === 0 || paginationRange.length < 2) {
    return null;
  }

  const onNext = () => {
    onPageChange(currentPage + 1);
  };

  const onPrevious = () => {
    onPageChange(currentPage - 1);
  };

  const lastPage = paginationRange[paginationRange.length - 1];

  const handlePageSubmit = () => {
    const page = Number(pageInput);

    if (!page || page < 1 || page > lastPage) {
      setPageInput(currentPage);
      return;
    }

    onPageChange(page);
  };

  return (
    <ul
      className={classnames("pagination-container flex justify-center py-2", {
        [className]: className,
      })}
    >
      {/* Previous Button */}
      <button
        className={classnames(
          "font-bold border-[1px] border-[#0A2341] p-2 rounded-lg mx-2 cursor-pointer disabled:opacity-15",
        )}
        disabled={currentPage === 1}
        onClick={onPrevious}
      >
        <img src={arrow} alt="Previous" />
      </button>

      {paginationRange.map((pageNumber, i) => {
        if (pageNumber === "...") {
          return (
            <li key={i} className="pagination-item dots">
              &#8230;
            </li>
          );
        }

        if (pageNumber === currentPage) {
          return (
            <li key={i} className="pagination-item">
              <input
                type="number"
                value={pageInput}
                className="bg-white w-12 h-9 rounded-lg text-center [&::-webkit-inner-spin-button]:appearance-none"
                onWheel={(e) => e.target.blur()}
                onChange={(e) => setPageInput(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handlePageSubmit();
                  }
                }}
                onBlur={handlePageSubmit}
              />
            </li>
          );
        }

        return (
          <li key={i} className="pagination-item" onClick={() => onPageChange(pageNumber)}>
            {pageNumber}
          </li>
        );
      })}

      {/* Next Button */}
      <button
        className={classnames(
          "font-bold border-[1px] border-[#0A2341] p-2 rounded-lg mx-2 cursor-pointer disabled:opacity-15",
        )}
        disabled={currentPage === lastPage}
        onClick={onNext}
      >
        <img src={arrow} alt="Next" className="rotate-180" />
      </button>
    </ul>
  );
};

export default Pagination;
